import React from "react";
import PaymentPage from "../components/payment/PaymentPage";
import Backbutton from "../components/Backbutton";

function Payment() {
    return (
        <>
            <PaymentPage />
        </>
    );
}

export default Payment;